import { useEffect, useState, useRef } from "react";
import * as API from "../../../Utils/Services/api";
import { useNavigate } from "react-router-dom";
import { Tooltip } from "react-tooltip";
import { ethers, BrowserProvider, Contract } from "ethers";
import { toast } from "react-toastify";
import {
  swapContract,
  poolContract,
} from "../../../Ethereum/Constant/addresses";
import { swapABI, poolABI, ERC20ABI } from "../../../Ethereum/Constant/abis";
import { contractInstance, signer } from "../../../Ethereum/Connect/config";
import ethImg from "../../../Assets/tinified/token-5.png";
import "./CreatePositions.css";
import Loading from "../../Loading/Loading";
import { useLanguage } from "../../LanguageContext";
import translation from "../../Translations/translation.json";
import { Helmet } from "react-helmet-async";
import SeoJson from "../../SeoJson";
import getTokenBalance from "../../../Utils/getTokenBalance";
import { Button, Dropdown, Modal } from "react-bootstrap";
// import V3CreatePositions from "./V3CreatePositions";
import CreatePositionsV3 from "./CreatePositionsV3";

const CreatePositions = () => {
  const { toggleLanguage, language } = useLanguage();
  const containerRef = useRef(null);
  const translate = (key) => {
    const keys = key.split(".");
    return (
      keys.reduce((obj, keyPart) => obj?.[keyPart], translation[language]) ||
      key
    );
  };
  const navigate = useNavigate();
  const url = "https://powdex.io/createPool";
  const title = `${translate("titleBar.createLiquidity")}`;
  // "Create Liquidity Pool on ETHW — Start a New Pair | PoWDex";
  const desc =
    "Create an ETHW liquidity pool on PoWDex. Set token addresses, choose amounts/ratio, and initialize your trading pair securely from your wallet.";
  const [toggle, setToggle] = useState(false);
  const [tokenData, setTokenData] = useState([]);
  const [selectedRadio, setSelectedRadio] = useState("0.3%");
  const [selectedRadioP, setSelectedRadioP] = useState("93%");
  const [value, setValue] = useState();
  const [value2, setValue2] = useState();
  const [depositVal, setDepositVal] = useState();
  const [depositVal2, setDepositVal2] = useState();
  const [estimateETHWValue, setEstimateETHWValue] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [estimateTokenValue, setEstimateTokenValue] = useState("");
  const [selectToken, setSelectToken] = useState(null);
  const [selectedToken, setSelectedToken] = useState(null);
  const [sortBy, setSortBy] = useState("");
  const [sortDirection, setSortDirection] = useState("");
  const [category, setCategory] = useState("");
  const [newPoolAddress, setNewPoolAddress] = useState("");
  const [loading, setLoading] = useState(false);
  const [allTokensLoading, setAllTokensLoading] = useState(false);
  const [depositloader, setDepositloader] = useState(false);
  const [checkPoolExist, setCheckPoolExist] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const [poolAddress, setPoolAddress] = useState(null);
  const debounceTimeout = useRef(null);
  const [totalAllTokens, setTotalAllTokens] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(30);
  const [totalPages, setTotalPages] = useState(1);
  const [version, setVersion] = useState("v3");
  const [currentPage, setCurrentPage] = useState(1);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [showResetModal, setShowResetModal] = useState(false);

  const handleClose = () => setShowResetModal(false);
  const handleShow = () => setShowResetModal(true);
  const handleReset = () => {
    setSelectedToken(null);
    handleClose();
  };
  const getAllTokenDetail = async (
    page = 1,
    size = rowsPerPage,
    filter = ""
  ) => {
    try {
      setAllTokensLoading(true);
      const data = {
        page,
        size,
        filter,
      };
      const resp = await API.getLiquidityToken(data);
      const tokens = resp?.data.tokens || [];
      setTokenData((prev) => (page === 1 ? tokens : [...prev, ...tokens]));
      setTotalAllTokens(resp.data.total);
      setTotalPages(Math.ceil(resp.data.total / size));
      setAllTokensLoading(false);
      // console.log("setTotalAllTokens", resp.data.total);
      // console.log("resp.data.allToken", resp.data.allToken.length);
    } catch (err) {
      toast.error(err.response.data.message);
      setAllTokensLoading(false);
      // console.log("57", err.response.data.message);
      // toast.error("Already paired")
      if (page === 1) setTokenData([]);
      setTotalAllTokens(0);
      setTotalPages(1);
    }
  };
  // useEffect(() => {
  //   getAllTokenDetail();
  // }, []);
  const handlePageChange = (newPage) => {
    if (newPage < 1 || newPage > totalPages) return;
    setCurrentPage(newPage);
    // getAllTokenDetail(newPage, rowsPerPage, selectToken || "");
  };

  // const handleRowsPerPageChange = (e) => {
  //   const newSize = Number(e.target.value);
  //   setRowsPerPage(newSize);
  //   setCurrentPage(1);
  //   getAllTokenDetail("", 1, newSize);
  // };

  // const selectHandler = async (e) => {
  //   try {
  //     const tokenContract = await contractInstance(e.target.value, ERC20ABI);
  //     const name = await tokenContract.name();
  //     const symbol = await tokenContract.symbol();

  //     if (name && symbol) {
  //       setTokenData([
  //         { image: "", name, symbol, contractAddress: e.target.value },
  //       ]);
  //     }
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };
  // Fetch token data from powtoken database
  const selectHandler = (e) => {
    const filter = e.target.value;
    // setSelectToken(filter);
    // Clear previous timeout
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }

    debounceTimeout.current = setTimeout(() => {
      setCurrentPage(1);
      setTokenData([]);
      // getAllTokenDetail(1, rowsPerPage, filter);
    }, 500);
  };
  const handleChange = (e) => {
    setValue(e.target.value.replace(/[^0-9]/g, ""));
  };
  const handleChange2 = (e) => {
    setValue2(e.target.value.replace(/[^0-9]/g, ""));
  };
  const handleDepositValChange = (e) => {
    setDepositVal(e.target.value.replace(/[^0-9]/g, ""));
  };
  const handleToggle = () => {
    setToggle(!toggle);
  };
  const handleGoBack = () => {
    navigate(-1);
  };
  const percentageMapping = {
    0.01: translate("addLiquidity.bestForVeryStable"),
    0.05: translate("addLiquidity.bestForStable"),
    0.3: translate("addLiquidity.bestForMost"),
    "1.00": translate("addLiquidity.bestForExotic"),
  };
  const handleSelection = (event) => {
    const value = event.target.value;
    setSelectedRadio(`${value}%`);
    setSelectedRadioP(percentageMapping[value]);
  };

  const saveHandler = async (data) => {
    // if (!selectToken) return;
    // const tokenContract = await contractInstance(
    //   data.contractAddress,
    //   ERC20ABI
    // );
    // const name = await tokenContract.name();
    // const symbol = await tokenContract.symbol();
    setSelectedToken(data);
    // Check if tokens pair created for selected token
    const swapInstance = await contractInstance(swapContract, swapABI);
    const poolAddress = await swapInstance.getPair(data.token.address);
    poolAddress !== "0x0000000000000000000000000000000000000000"
      ? setCheckPoolExist(true)
      : setCheckPoolExist(false);
    // setSelectedToken(selectToken);
    setSelectToken(null);
  };

  const createPairHandler = async () => {
    if (!sessionStorage.getItem("account")) {
      // toast.error("Please connect metamask wallet");
      toast.error(`${translate("pleaseConnectMetamask")}`);
      return;
    }
    if (checkPoolExist) return toast.info(`${translate("pairAlreadyExist")}`);
    try {
      setLoading(true);
      // if (!window.ethereum) {
      //   toast.warn("MetaMask not detected. Please install it!");
      //   return;
      // }

      // const provider = new BrowserProvider(window.ethereum);
      // await provider.send("eth_requestAccounts", []);
      // const signer = await provider.getSigner();
      // const contract = new Contract(swapContract, swapABI, signer);
      const contract = await contractInstance(swapContract, swapABI);

      // const account = await contract.getPair(
      //   "0x16b6758e952b24f35b94d3ef38a9b6c371431afd"
      // );
      const tx = await contract.createPool(
        selectedToken.token.address,
        `ETHW/${selectedToken.token.symbol}`,
        `ETHW/${selectedToken.token.symbol}`
      );

      // toast.info("Transaction sent! Waiting for confirmation...");
      toast.info(`${translate("txPending")}`);
      const receipt = await tx.wait();
      // const poolCreatedAddress = receipt.logs[0].address;
      // setNewPoolAddress(poolCreatedAddress);
      setCheckPoolExist(true);
      // toast.success("Pair created successfully!");
      toast.success(`${translate("pairCreatedSuccess")}`);
      setLoading(false);
    } catch (error) {
      // console.log(error.reason);
      if (error.reason) {
        setLoading(false);
        // console.log("183", error.reason);
        // return toast.error("Request Denied");
        return toast.error(`${translate("requestDenied")}`);
      } else {
        setLoading(false);
        // console.log("187", "sometng");
        // return toast.error("Please select token");
        return toast.error(`${translate("pleaseSelectToken")}`);
      }
      setLoading(false);
    }
  };

  const depositHandler = async () => {
    if (!sessionStorage.getItem("account")) {
      // toast.error("Please connect metamask wallet");
      toast.error(`${translate("pleaseConnectMetamask")}`);
      return;
    }
    try {
      setDepositloader(true);
      // if (!window.ethereum) {
      //   toast.warn("MetaMask not detected. Please install it!");
      //   return;
      // }

      // const provider = new BrowserProvider(window.ethereum);
      // await provider.send("eth_requestAccounts", []);
      const userSigner = await signer();
      const walletAddress = await userSigner.getAddress();
      // const contract = new Contract(poolContract, poolABI, signer);
      // const tokenContract = new Contract(selectedToken, ERC20ABI, signer);
      // console.log(
      //   "selectedToken.contractAddress",
      //   selectedToken.contractAddress
      // );
      const swapInstance = await contractInstance(swapContract, swapABI);
      const poolAddress = await swapInstance.getPair(
        selectedToken.token.address
      );
      const contract = await contractInstance(poolAddress, poolABI);

      const lpTokenAddress = await contract.getLPTokenAddress();

      const tokenContract = await contractInstance(
        selectedToken.token.address,
        ERC20ABI
      );
      const depositAmount1 = ethers.parseEther(estimateETHWValue);
      const depositAmount2 = ethers.parseEther(estimateTokenValue);

      const approveTx = await tokenContract.approve(
        poolAddress,
        depositAmount2
      );
      // toast.info("Approve transaction sent! Waiting for confirmation...");
      toast.info(`${translate("approveTxPending")}`);
      await approveTx.wait();
      toast.success(`${translate("approvalSuccess")}`);
      // toast.success("Approval successfull!");

      // toast.info("Please confirm again for the transaction in metamask!");
      toast.info(`${translate("confirmInMetamask")}`);
      const tx = await contract.addLiquidity(depositAmount2, {
        value: depositAmount1,
      });
      // toast.info("Transaction sent! Waiting for confirmation...");
      toast.info(`${translate("txPending")}`);
      const receipt = await tx.wait();

      const ethwReserve = await contract.ethwReserve();
      const tokenReserve = await contract.tokenReserve();

      const createdBlock = receipt.blockNumber;
      const createdTx = receipt.hash;

      const selectedTokenDetails = tokenData.find(
        (token) => token.token.address === selectedToken.token.address
      );
      const selectedTokenDescription = tokenData.find(
        (token) => token.description === selectedToken.description
      );
      const imageUrl = selectedTokenDetails?.image || "";

      // const data = {
      //   poolAddress: poolAddress,
      //   tokenAddress: selectedToken.contractAddress,
      //   walletAddress: walletAddress,
      //   ethwAmount: parseFloat(estimateETHWValue),
      //   tokenAmount: parseFloat(estimateTokenValue),
      //   tokenName: `ETHW/${selectedToken.symbol}`,
      //   imageUrl: imageUrl,
      //   description: selectedToken.description,
      // };

      // const resp = await API.CreatePair(data);
      const getTokenBal = await getTokenBalance(selectedToken.token.address);

      const resp = await API.addLiquidity({
        tokenAddress: selectedToken.token.address,
        poolAddress,
        pairAddress: lpTokenAddress,
        wallet: walletAddress,
        tokenAmount: parseFloat(estimateTokenValue),
        ethwAmount: parseFloat(estimateETHWValue),
        ethwReserve: parseFloat(ethers.formatEther(ethwReserve.toString())),
        tokenReserve: parseFloat(ethers.formatEther(tokenReserve.toString())),
        createdBlock: createdBlock,
        createdTx: createdTx,
        tokenBalance: getTokenBal,
      });

      // alert(`PoolAddress store it somewhere: ${poolAddress}`);
      setPoolAddress(poolAddress);
      setShowModal(true);

      if (resp.data.status) {
        toast.success(`${translate("liquidityCreatedSuccess")}`);
      }
      setDepositloader(false);
      // console.log(
      //   "ETHW, Token",
      //   await contract.ethwReserve(),
      //   await contract.tokenReserve()
      // );
    } catch (err) {
      if (err.action) {
        toast.error(
          `Check if ${selectedToken.token.symbol} exists in your wallet`
        );
        setDepositloader(false);
      } else {
        // toast.error("Please enter valid amount");
        toast.info(`${translate("enterValidDetails")}`);
        setDepositloader(false);
      }
      setDepositloader(false);
    }
  };
  const closeModal = () => {
    setShowModal(false);
  };
  /// Estimate ETHW value from token input value
  const handleTokenInput = (e) => {
    // setValue(e.target.value.replace(/[^0-9]/g, ""));

    const value = e.target.value !== "" ? e.target.value : "";
    setEstimateTokenValue(value);
    if (!value) {
      setEstimateETHWValue("");
      return;
    }

    if (!selectedToken) return;

    // Clear previous timeout
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }

    // Set new debounce timeout
    debounceTimeout.current = setTimeout(async () => {
      try {
        const swapInstance = await contractInstance(swapContract, swapABI);
        const poolAddress = await swapInstance.getPair(
          selectedToken.token.address
        );
        const contract = await contractInstance(poolAddress, poolABI);
        const tokenPoolReserveValue = await contract.tokenReserve();
        const convertToString = ethers.formatEther(
          tokenPoolReserveValue.toString()
        );
        const convertToFloat = parseFloat(convertToString);

        if (convertToFloat <= 0) return;

        const expectedTokenOut = await contract.getRequiredEthwAmount(
          ethers.parseEther(value)
        );
        setEstimateETHWValue(ethers.formatEther(String(expectedTokenOut)));
      } catch (err) {
        if (err.reason === "Insufficient pool reserves")
          // return toast.error("Insufficient pool reserves");
          return toast.error(`${translate("insufficientPoolReserves")}`);
        if (err.reason === "Panic due to DIVIDE_BY_ZERO(18)")
          // return toast.error("Liquidity pool not exist!");
          return toast.error(`${translate("liquidityNotExist")}`);

        toast.error(err.reason);
      }
    }, 500);
  };

  /// Estimate Token value from ETHW input value
  const handleETHWInput = (e) => {
    // setValue(e.target.value.replace(/[^0-9]/g, ""));
    const value = e.target.value !== "" ? e.target.value : "";
    setEstimateETHWValue(value);
    if (!value) {
      setEstimateTokenValue("");
      return;
    }
    if (!selectedToken) return;

    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }
    debounceTimeout.current = setTimeout(async () => {
      try {
        const swapInstance = await contractInstance(swapContract, swapABI);
        const poolAddress = await swapInstance.getPair(
          selectedToken.token.address
        );
        const contract = await contractInstance(poolAddress, poolABI);
        const ethwRoolReserverValue = await contract.ethwReserve();
        const convertToString = ethers.formatEther(
          ethwRoolReserverValue.toString()
        );
        const convertToFloat = parseFloat(convertToString);

        if (convertToFloat <= 0) return;

        const expectedTokenOut = await contract.getRequiredTokenAmount(
          ethers.parseEther(value)
        );
        setEstimateTokenValue(ethers.formatEther(String(expectedTokenOut)));
      } catch (err) {
        if (err.reason === "Insufficient pool reserves") return;
        if (err.reason === "Panic due to DIVIDE_BY_ZERO(18)")
          // return toast.error("Liquidity pool not exist!");
          return toast.error(`${translate("liquidityNotExist")}`);

        toast.error(err.reason);
        // console.log("352", err.reason);
      }
    }, 500);
  };
  const handleCopy = (address) => {
    navigator.clipboard
      .writeText(address)
      .then(() => {
        // toast.success("Copied Successfully");
        toast.success(`${translate("copiedSuccessfully")}`);
      })
      .catch((err) => {
        toast.error("Error");
      });
  };

  const handleScroll = () => {
    const container = containerRef.current;
    if (!container || allTokensLoading) return;

    if (
      container.scrollTop + container.clientHeight >=
      container.scrollHeight - 50
    ) {
      if (currentPage < totalPages) {
        const nextPage = currentPage + 1;
        setCurrentPage(nextPage);
        // getAllTokenDetail(nextPage, rowsPerPage, selectToken || "");
      }
    }
  };

  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={desc} />
        <link rel="canonical" href={url} />

        {/* OG / Twitter */}
        <meta property="og:site_name" content="PoWDex" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={desc} />
        <meta property="og:url" content={url} />
        <meta
          property="og:image"
          content="https://powdex.io/og-create-pool.jpg"
        />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>

      {/* WebApplication schema for this tool */}
      <SeoJson
        data={{
          "@context": "https://schema.org",
          "@type": "WebApplication",
          name: "PoWDex Create Pool",
          url,
          operatingSystem: "Web",
          applicationCategory: "FinanceApplication",
          description: desc,
        }}
      />

      {/* HowTo schema: creating a new pool */}
      <SeoJson
        data={{
          "@context": "https://schema.org",
          "@type": "HowTo",
          name: "How to create an ETHW liquidity pool on PoWDex",
          step: [
            {
              "@type": "HowToStep",
              name: "Enter token addresses",
              text: "Paste the two ERC-20 contract addresses (0x…) you want to pair (e.g., TOKEN/ETHW).",
            },
            {
              "@type": "HowToStep",
              name: "Set initial amounts & ratio",
              text: "Choose how much of each token to deposit. Review the initial price implied by your ratio.",
            },
            {
              "@type": "HowToStep",
              name: "Approve tokens (if required)",
              text: "Approve spending for each token in your wallet before creating the pool.",
            },
            {
              "@type": "HowToStep",
              name: "Create pool",
              text: "Click Create Pool and confirm the transaction in your wallet to initialize the pair.",
            },
          ],
        }}
      />

      {/* Optional FAQ rich results (safe, timeless) */}
      <SeoJson
        data={{
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: [
            {
              "@type": "Question",
              name: "What fees do I pay when creating a pool?",
              acceptedAnswer: {
                "@type": "Answer",
                text: "You pay network gas and any protocol fees shown in the UI. Exact costs appear in your wallet before confirmation.",
              },
            },
            {
              "@type": "Question",
              name: "Can I add more liquidity later?",
              acceptedAnswer: {
                "@type": "Answer",
                text: "Yes. After the pool is created, use Add Liquidity to deposit more tokens at the current pool price.",
              },
            },
          ],
        }}
      />

      <main>
        <div
          className="create-positions-ht view-positions-pg add-liquidity-pg"
          style={{ height: selectedToken && checkPoolExist ? "100%" : "100vh" }}
        >
          {" "}
          <div className="gradient-bg-circle-2"> </div>
          <div className="gradient-bg-circle"></div>
          <div className="container">
            {" "}
            <div className="page-width-vp">
              <div className="create-position-options">
                <div className="all-positions-optn-btns">
                  <Button
                    variant=""
                    className="text-light add-liquidity-sel-token modal-btn-back-css"
                    onClick={handleShow}
                    disabled={!selectedToken}
                  >
                    <i className="fa fa-arrow-rotate-left"></i>{" "}
                    {translate("addLiquidity.reset")}
                  </Button>

                  <Modal
                    show={showResetModal}
                    onHide={handleClose}
                    scrollable
                    centered
                    className="modal-reset-modal"
                    contentClassName="text-center"
                  >
                    <Modal.Header closeButton></Modal.Header>
                    <Modal.Body
                      style={{ maxHeight: "80vh", overflowY: "auto" }}
                    >
                      <i className="fa fa-regular fa-circle-question fa-2xl mt-3"></i>
                      <h5 className="mt-2">
                        {/* Are you sure? */}
                        {translate("addLiquidity.sure")}
                      </h5>
                      <p>
                        {translate("addLiquidity.resetMsg")}
                        {/* Your tokens, price, and range selections will be reset. */}
                      </p>
                      <div className="cancel-or-reset-modal">
                        <Button
                          onClick={handleClose}
                          className="cancel-reset-modal-btn"
                        >
                          {/* Cancel */}
                          {translate("buttons.cancel")}
                        </Button>
                        <Button
                          className="submit-reset-modal-btn"
                          onClick={handleReset}
                        >
                          {/* Reset */}
                          {translate("addLiquidity.reset")}
                        </Button>
                      </div>
                    </Modal.Body>
                  </Modal>
                  {/* <Dropdown>
                    <Dropdown.Toggle
                      variant="none"
                      id="version-dropdown"
                      className="btn text-light add-liquidity-sel-token modal-btn-back-css"
                    >
                      {version}
                    </Dropdown.Toggle>

                    <Dropdown.Menu className="dropdown-menu-selection-v2-v3">
                      <Dropdown.Item onClick={() => setVersion("v2")}>
                        {translate("addLiquidity.newv2Position")}
                      </Dropdown.Item>
                      <Dropdown.Item onClick={() => setVersion("v3")}>
                        {translate("addLiquidity.newv3Position")}
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown> */}
                </div>
              </div>
              {version === "v2" && (
                <div className="createpositons-pg create-liquidyt-relative">
                  <div className="migrate-pg-heading bg-none">
                    <div>
                      <i
                        onClick={handleGoBack}
                        className="fa fa-arrow-left"
                      ></i>
                    </div>
                    <div className="add-liquidity-heading">
                      {translate("addLiquidity.heading")}
                    </div>
                    <div>
                      {(value?.length > 0 ||
                        value2?.length > 0 ||
                        depositVal?.length > 0) && (
                        <div className="clear-all-btn">
                          <button
                            onClick={() => {
                              setValue("");
                              setValue2("");
                              setDepositVal("");
                            }}
                          >
                            {translate("addLiquidity.clearAll")}
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="migrate-pg-body bg-none">
                    <p>{translate("addLiquidity.selectPair")}</p>
                    <div className="div-add-positons-btn">
                      <div className="add-postions-form-btn selected-token-btn add-pos-btn">
                        <button
                          type="button"
                          // className="btn btn-modal-backdrop"
                          className="btn backdrop-btn-css backdrop-no-modal-btn"
                          // data-bs-toggle="modal"
                          // data-bs-target="#exampleModal"
                        >
                          <div className="flex-class text-white ">
                            <div>
                              <img
                                src="https://res.cloudinary.com/dbtsrjssc/image/upload/v1733220306/B870CB730078368E_tedoei.webp"
                                alt=""
                                className="modal-img-btn me-2 mb-1"
                              />
                              ETHW
                            </div>{" "}
                            {/* <div>
                        {" "}
                        <i className="fa fa-angle-down grey-clr"></i>
                      </div> */}
                          </div>
                        </button>
                      </div>
                      <div className="add-postions-form-btn select-token-btn">
                        <button
                          type="button"
                          className="btn add-liquidity-sel-token modal-btn-back-css"
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal2"
                        >
                          {selectedToken ? (
                            <>
                              <div className="flex-class text-white ">
                                <div>
                                  <img
                                    src={selectedToken.token.image}
                                    alt=""
                                    className="modal-img-btn me-2 mb-1"
                                  />
                                  {selectedToken.token.symbol}
                                </div>{" "}
                                <div>
                                  {" "}
                                  <i className="fa fa-angle-down grey-clr"></i>
                                </div>
                              </div>
                            </>
                          ) : (
                            <>
                              <div className="flex-class text-white ">
                                {translate("banner.actions.selectToken")}
                                <i className="fa fa-angle-down grey-clr"></i>
                              </div>
                            </>
                          )}
                        </button>

                        <div
                          className="modal "
                          id="exampleModal2"
                          tabIndex={-1}
                          aria-labelledby="exampleModalLabel"
                          aria-hidden="true"
                        >
                          <div className="modal-dialog modal-dialog-scrollable text-white">
                            <div className="modal-content">
                              <div className="modal-header">
                                <h1
                                  className="modal-title fs-5"
                                  id="exampleModalLabel"
                                >
                                  {translate("banner.actions.selectToken")}
                                </h1>
                                <button
                                  type="button"
                                  className="btn-close"
                                  data-bs-dismiss="modal"
                                  aria-label="Close"
                                ></button>
                              </div>
                              <div
                                className="modal-body"
                                ref={containerRef}
                                onScroll={handleScroll}
                                style={{ maxHeight: "80vh", overflowY: "auto" }}
                              >
                                <input
                                  type="text"
                                  name="userToken"
                                  placeholder={translate(
                                    "enterContractAddress"
                                  )}
                                  className="form-control search-input-box search-input-box-2 pt-2 pb-2 mb-2"
                                  // value={selectToken}

                                  // onChange={(e) => setSelectToken(e.target.value)}
                                  onChange={selectHandler}
                                  autoComplete="off"
                                />
                                {tokenData.length === 0 && allTokensLoading && (
                                  <Loading />
                                )}

                                {tokenData.length === 0 &&
                                  !allTokensLoading && (
                                    <div className="suggestion-item">
                                      {translate("noResultFound")}
                                    </div>
                                  )}
                                {tokenData && tokenData.length > 0 && (
                                  <>
                                    {tokenData.map((suggestion, index) => (
                                      <div
                                        key={index}
                                        className="suggestion-item tokrn-suggestion-data"
                                        data-bs-dismiss="modal"
                                        onClick={() => saveHandler(suggestion)}
                                      >
                                        <div className="suggestion-img">
                                          <img
                                            src={suggestion?.token.image}
                                            alt=""
                                          />
                                        </div>
                                        <div
                                          className="model-data-flex"
                                          style={{ textAlign: "left" }}
                                        >
                                          <div className="suggestion-name">
                                            {suggestion?.token.name} (
                                            <strong>
                                              {suggestion?.token.symbol?.toUpperCase()}
                                            </strong>
                                            )
                                          </div>
                                          <div className="suggestion-sym contract-add-model">
                                            {suggestion?.token.address}
                                          </div>
                                        </div>
                                      </div>
                                    ))}
                                    {allTokensLoading && <Loading />}{" "}
                                    {/* Bottom loader for infinite scroll */}
                                  </>
                                )}
                              </div>
                              {/* <div className="modal-footer get-started-btn ok-btn">
                          <button
                            type="button"
                            className="btn text-white "
                            data-bs-dismiss="modal"
                            onClick={saveHandler}
                          >
                            {translate("ok")}
                          </button>
                        </div> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="get-started-btn create-pair-btn mt-4"
                      onClick={createPairHandler}
                    >
                      <button className="text-white " disabled={checkPoolExist}>
                        {loading ? (
                          <Loading />
                        ) : checkPoolExist ? (
                          translate("addLiquidity.paired")
                        ) : (
                          translate("addLiquidity.createPair")
                        )}
                      </button>
                    </div>
                    <div className="fee-tier-div">
                      <div>
                        <p>
                          {selectedRadio} {translate("addLiquidity.feeTier")}
                        </p>
                        <p>
                          {selectedRadioP}{" "}
                          {translate("addLiquidity.selectPercentage")}
                        </p>
                      </div>
                      {/* <div onClick={handleToggle}>{toggle ? "Hide" : "Edit"}</div> */}
                      <div>{translate("addLiquidity.fee")}</div>
                    </div>

                    {selectedToken && checkPoolExist && (
                      <>
                        <p className="mt-3">
                          {translate("addLiquidity.amounts")}
                        </p>
                        <div className="set-price-range">
                          <div>
                            <span>ETHW</span>

                            <span>
                              <div className="grey-color">
                                <input
                                  type="text"
                                  value={estimateETHWValue}
                                  // onChange={(e) => setDepositVal(e.target.value)}
                                  onChange={handleETHWInput}
                                  min={0}
                                  placeholder="0"
                                  id="number-input-form"
                                  className="text-white "
                                  autoComplete="off"
                                />
                              </div>
                            </span>
                          </div>
                        </div>
                        <div className="set-price-range">
                          <div>
                            <span>
                              {selectedToken
                                ? selectedToken.token.symbol
                                : translate("banner.actions.selectToken")}
                            </span>

                            <span>
                              <div className="grey-color">
                                <input
                                  type="text"
                                  value={estimateTokenValue}
                                  // onChange={(e) => setDepositVal2(e.target.value)}
                                  onChange={handleTokenInput}
                                  min={1}
                                  placeholder="1"
                                  id="number-input-form"
                                  autoComplete="off"
                                  className="text-white "
                                />
                              </div>
                            </span>
                          </div>
                        </div>
                        <div
                          className="get-started-btn create-pair-btn mt-4"
                          onClick={depositHandler}
                        >
                          <button
                            className="text-white"
                            disabled={depositloader}
                          >
                            {depositloader ? (
                              <Loading />
                            ) : (
                              translate("addLiquidity.deposit")
                            )}
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                  {showModal && (
                    <div
                      className="modal modal-backcss show d-block"
                      id="staticBackdrop"
                      data-bs-backdrop="static"
                      data-bs-keyboard="false"
                      tabindex="-1"
                      aria-labelledby="staticBackdropLabel"
                      aria-hidden="true"
                    >
                      <div
                        className="modal-dialog   modal-dialog-centered"
                        role="document"
                      >
                        <div className="modal-content text-center">
                          <div className="modal-header">
                            <h5 className="modal-title">
                              {/* LP Address */}
                              {translate("lpAddressLabel")}
                            </h5>
                            <button
                              type="button"
                              className="btn-close"
                              aria-label="Close"
                              onClick={closeModal}
                            ></button>
                          </div>
                          <div className="modal-body">
                            <p style={{ marginBottom: "0" }}>
                              {/* Save this Liquidity Pool Address somewhere:  */}
                              {translate("lpAddressNote")} <br />
                              {poolAddress}{" "}
                              <i
                                className="fa fa-copy ms-1"
                                style={{ cursor: "pointer" }}
                                onClick={() => handleCopy(poolAddress)}
                              ></i>
                            </p>
                          </div>
                          <div className="modal-footer">
                            <button
                              style={{
                                backgroundColor: "#00a8e8",
                                color: "#fff",
                                fontWeight: "500",
                              }}
                              type="button"
                              className="btn"
                              onClick={closeModal}
                            >
                              Close
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )}
              {/* {version === "v3" && (
                <div className="createpositons-pg create-liquidyt-relative">
                  <div className="migrate-pg-heading bg-none">
                    <div>
                      <i
                        onClick={handleGoBack}
                        className="fa fa-arrow-left"
                      ></i>
                    </div>
                    <div className="add-liquidity-heading">
                      {translate("addLiquidity.heading")}
                    </div>
                    <div>
                      {(value?.length > 0 ||
                        value2?.length > 0 ||
                        depositVal?.length > 0) && (
                        <div className="clear-all-btn">
                          <button
                            onClick={() => {
                              setValue("");
                              setValue2("");
                              setDepositVal("");
                            }}
                          >
                            {translate("addLiquidity.clearAll")}
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="migrate-pg-body bg-none">
                    <p>{translate("addLiquidity.selectPair")}</p>
                    <div className="div-add-positons-btn">
                      <div className="add-postions-form-btn selected-token-btn add-pos-btn">
                        <button
                          type="button"
                          className="btn backdrop-btn-css backdrop-no-modal-btn"
                          
                        >
                          <div className="flex-class text-white ">
                            <div>
                              <img
                                src="https://res.cloudinary.com/dbtsrjssc/image/upload/v1733220306/B870CB730078368E_tedoei.webp"
                                alt=""
                                className="modal-img-btn me-2 mb-1"
                              />
                              ETHW
                            </div>{" "}
                           
                          </div>
                        </button>
                      </div>
                      <div className="add-postions-form-btn select-token-btn">
                        <button
                          type="button"
                          className="btn add-liquidity-sel-token modal-btn-back-css"
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal2"
                        >
                          {selectedToken ? (
                            <>
                              <div className="flex-class text-white ">
                                <div>
                                  <img
                                    src={selectedToken.token.image}
                                    alt=""
                                    className="modal-img-btn me-2 mb-1"
                                  />
                                  {selectedToken.token.symbol}
                                </div>{" "}
                                <div>
                                  {" "}
                                  <i className="fa fa-angle-down grey-clr"></i>
                                </div>
                              </div>
                            </>
                          ) : (
                            <>
                              <div className="flex-class text-white ">
                                {translate("banner.actions.selectToken")}
                                <i className="fa fa-angle-down grey-clr"></i>
                              </div>
                            </>
                          )}
                        </button>

                        <div
                          className="modal "
                          id="exampleModal2"
                          tabIndex={-1}
                          aria-labelledby="exampleModalLabel"
                          aria-hidden="true"
                        >
                          <div className="modal-dialog modal-dialog-scrollable text-white">
                            <div className="modal-content">
                              <div className="modal-header">
                                <h1
                                  className="modal-title fs-5"
                                  id="exampleModalLabel"
                                >
                                  {translate("banner.actions.selectToken")}
                                </h1>
                                <button
                                  type="button"
                                  className="btn-close"
                                  data-bs-dismiss="modal"
                                  aria-label="Close"
                                ></button>
                              </div>
                              <div
                                className="modal-body"
                                ref={containerRef}
                                onScroll={handleScroll}
                                style={{ maxHeight: "80vh", overflowY: "auto" }}
                              >
                                <input
                                  type="text"
                                  name="userToken"
                                  placeholder={translate(
                                    "enterContractAddress"
                                  )}
                                  className="form-control search-input-box search-input-box-2 pt-2 pb-2 mb-2"
                                  onChange={selectHandler}
                                  autoComplete="off"
                                />
                                {tokenData.length === 0 && allTokensLoading && (
                                  <Loading />
                                )}

                                {tokenData.length === 0 &&
                                  !allTokensLoading && (
                                    <div className="suggestion-item">
                                      {translate("noResultFound")}
                                    </div>
                                  )}
                                {tokenData && tokenData.length > 0 && (
                                  <>
                                    {tokenData.map((suggestion, index) => (
                                      <div
                                        key={index}
                                        className="suggestion-item tokrn-suggestion-data"
                                        data-bs-dismiss="modal"
                                        onClick={() => saveHandler(suggestion)}
                                      >
                                        <div className="suggestion-img">
                                          <img
                                            src={suggestion?.token.image}
                                            alt=""
                                          />
                                        </div>
                                        <div
                                          className="model-data-flex"
                                          style={{ textAlign: "left" }}
                                        >
                                          <div className="suggestion-name">
                                            {suggestion?.token.name} (
                                            <strong>
                                              {suggestion?.token.symbol?.toUpperCase()}
                                            </strong>
                                            )
                                          </div>
                                          <div className="suggestion-sym contract-add-model">
                                            {suggestion?.token.address}
                                          </div>
                                        </div>
                                      </div>
                                    ))}
                                    {allTokensLoading && <Loading />}{" "}
                                  </>
                                )}
                              </div>
                            
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style={{ margin: 6 }}>
                      Init price
                      <input
                        value={price}
                        onChange={(e) => setPrice(e.target.value)}
                        placeholder="1.0"
                        inputMode="decimal"
                        style={{ width: "100%" }}
                      />
                    </div>

                    <div className="fee-tier-div">
                      <div>
                        <p>
                          {selectedRadio} {translate("addLiquidity.feeTier")}
                        </p>
                        <p>
                          {selectedRadioP}{" "}
                          {translate("addLiquidity.selectPercentage")}
                        </p>
                      </div>
                      <div className="hide-edit-btn" onClick={handleToggle}>
                        {toggle
                          ? translate("addLiquidity.HideFee")
                          : translate("addLiquidity.editFee")}{" "}
                      </div>
                    </div>
                    {toggle && (
                      <div className="toggle-selection-fee toggle-row">
                        {Object.keys(percentageMapping).map((key) => (
                          <div className="" key={key}>
                            <div className="fee-tier-div">
                              <input
                                type="radio"
                                id={key}
                                name="fee-tier-radio"
                                value={key}
                                checked={selectedRadio === `${key}%`}
                                onChange={handleSelection}
                              />
                              <label htmlFor={key}>
                                {key}% <br />
                                <span>{percentageMapping[key]}</span>
                              </label>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}

                    <div
                      className="get-started-btn create-pair-btn mt-4"
                      onClick={createPairHandler}
                    >
                      <button className="text-white " disabled={checkPoolExist}>
                        {loading ? (
                          <Loading />
                        ) : checkPoolExist ? (
                          translate("addLiquidity.paired")
                        ) : (
                          translate("addLiquidity.createPair")
                        )}
                      </button>
                    </div>

                    {selectedToken && checkPoolExist && (
                      <>
                        <p className="mt-3">
                          {translate("addLiquidity.amounts")}
                        </p>
                        <div className="set-price-range">
                          <div>
                            <span>ETHW</span>

                            <span>
                              <div className="grey-color">
                                <input
                                  type="text"
                                  value={estimateETHWValue}
                                  onChange={handleETHWInput}
                                  min={0}
                                  placeholder="0"
                                  id="number-input-form"
                                  className="text-white "
                                  autoComplete="off"
                                />
                              </div>
                            </span>
                          </div>
                        </div>
                        <div className="set-price-range">
                          <div>
                            <span>
                              {selectedToken
                                ? selectedToken.token.symbol
                                : translate("banner.actions.selectToken")}
                            </span>

                            <span>
                              <div className="grey-color">
                                <input
                                  type="text"
                                  value={estimateTokenValue}
                                  onChange={handleTokenInput}
                                  min={1}
                                  placeholder="1"
                                  id="number-input-form"
                                  autoComplete="off"
                                  className="text-white "
                                />
                              </div>
                            </span>
                          </div>
                        </div>
                        <div
                          className="get-started-btn create-pair-btn mt-4"
                          onClick={depositHandler}
                        >
                          <button
                            className="text-white"
                            disabled={depositloader}
                          >
                            {depositloader ? (
                              <Loading />
                            ) : (
                              translate("addLiquidity.deposit")
                            )}
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                  {showModal && (
                    <div
                      className="modal modal-backcss show d-block"
                      id="staticBackdrop"
                      data-bs-backdrop="static"
                      data-bs-keyboard="false"
                      tabindex="-1"
                      aria-labelledby="staticBackdropLabel"
                      aria-hidden="true"
                    >
                      <div
                        className="modal-dialog   modal-dialog-centered"
                        role="document"
                      >
                        <div className="modal-content text-center">
                          <div className="modal-header">
                            <h5 className="modal-title">
                              {translate("lpAddressLabel")}
                            </h5>
                            <button
                              type="button"
                              className="btn-close"
                              aria-label="Close"
                              onClick={closeModal}
                            ></button>
                          </div>
                          <div className="modal-body">
                            <p style={{ marginBottom: "0" }}>
                              {translate("lpAddressNote")} <br />
                              {poolAddress}{" "}
                              <i
                                className="fa fa-copy ms-1"
                                style={{ cursor: "pointer" }}
                                onClick={() => handleCopy(poolAddress)}
                              ></i>
                            </p>
                          </div>
                          <div className="modal-footer">
                            <button
                              style={{
                                backgroundColor: "#00a8e8",
                                color: "#fff",
                                fontWeight: "500",
                              }}
                              type="button"
                              className="btn"
                              onClick={closeModal}
                            >
                              Close
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )} */}
              {version === "v3" && <CreatePositionsV3 />}
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default CreatePositions;
